export const getAttribution = (state) => {
  const poi = state.pois && state.pois.initial;

  if (!poi) {
    return [];
  }

  const { imageAssociations: associations } = poi;

  if (!associations) return [];

  return (Array.isArray(associations) ? associations : [associations]).reduce((memo, { from }) => {
    if (from && from.attribution) {
      const [attribution] = from.attribution;

      if (attribution) {
        memo.push(attribution);
      }
    }

    return memo;
  }, []);
};



// WEBPACK FOOTER //
// ./assets/pois/selectors/index.js